module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart"
  }, [_c('div', {
    staticClass: "main"
  }, [(_vm.addressList && _vm.addressList.length > 0) ? _c('div', {
    staticClass: "list address-list"
  }, [_c('ul', _vm._l((_vm.addressList), function(item) {
    return _c('li', {
      class: !item.isVaild && _vm.isForm ? 'vaild' : ''
    }, [_c('div', {
      staticClass: "delete-btn"
    }, [_vm._v("删除")]), _vm._v(" "), _c('div', {
      staticClass: "swiper-container swiper-delete swiper-container-horizontal"
    }, [_c('div', {
      staticClass: "swiper-wrapper"
    }, [_c('div', {
      staticClass: "content swiper-slide",
      on: {
        "click": function($event) {
          return _vm.handleClickChooseAddress(item)
        }
      }
    }, [_c('div', {
      staticClass: "content-box",
      staticStyle: {
        "width": "100%"
      }
    }, [(!item.isLimitFloor) ? _c('div', {
      staticClass: "item ellipses-two",
      class: !item.isVaild && _vm.isForm ? 'opa-5' : ''
    }, [(item.detail && item.poi_address) ? _c('span', [_vm._v(_vm._s(item.poi_address) + _vm._s(item.detail))]) : (item.build_name) ? _c('span', [_vm._v("【" + _vm._s(item.build_name) + "-" + _vm._s(item.floor_name) + "-" + _vm._s(item.room_name) + "】")]) : _c('span', [_vm._v(_vm._s(item.poi_address))])]) : _c('div', {
      staticClass: "item ellipses-two",
      class: !item.isVaild && _vm.isForm ? 'opa-5' : ''
    }, [(item.build_name) ? _c('span', [_vm._v("【" + _vm._s(item.build_name) + "-" + _vm._s(item.floor_name) + "-" + _vm._s(item.room_name) + "】")]) : _c('span', [_vm._v(_vm._s(item.poi_address) + " " + _vm._s(item.detail))])]), _vm._v(" "), _c('span', {
      staticClass: "address",
      class: !item.isVaild && _vm.isForm ? 'opa-5' : ''
    }, [_vm._v(_vm._s(item.addressee) + " " + _vm._s(item.mp))])]), _vm._v(" "), (item.isVaild || !_vm.isForm) ? _c('a', {
      staticClass: "icon icon-edit",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editAddress(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!item.isVaild && _vm.isForm) ? _c('a', {
      staticClass: "iconEdit",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editAddress(item)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": ".38rem",
        "height": ".38rem"
      },
      attrs: {
        "src": require("../assets/images/edit.png")
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "line-height": ".38rem",
        "margin-left": "0.05rem"
      }
    }, [_vm._v("完善信息")])]) : _vm._e(), _vm._v(" "), _c('div', {
      class: {
        choose: item.id === _vm.chooseAddress.id && (item.isVaild || !_vm.isForm)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "delete-btn2 swiper-slide",
      on: {
        "click": function($event) {
          return _vm.handleClickDeleteAddress(item)
        }
      }
    })])])])
  }), 0)]) : _c('div', {
    staticClass: "no-info"
  }, [_vm._m(0)])]), _vm._v(" "), _c('footer', {
    staticClass: "block fixed"
  }, [_c('a', {
    staticClass: "btn btn-main btn-lg btn-block",
    on: {
      "click": _vm.toAddAddress
    }
  }, [_vm._v("新增收货地址")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/empty-01.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("这里没有收货地址")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-147951c4","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/AddressList.vue
// module id = 412
// module chunks = 7